import { render } from "./BookingFormEmergencyContact.vue?vue&type=template&id=4274443c&scoped=true"
import script from "./BookingFormEmergencyContact.vue?vue&type=script&lang=js"
export * from "./BookingFormEmergencyContact.vue?vue&type=script&lang=js"

import "./BookingFormEmergencyContact.vue?vue&type=style&index=0&id=4274443c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4274443c"]])

export default __exports__